module.exports = __webpack_public_path__ + "media/images/banner/tjt/sp/travel01_1280_1280_zh-hant-9cd8ec15a12c53965350cf1cb8790ff9.jpg";